module.exports = __webpack_public_path__ + "img/FCHS_ER_2023-4.3e960ec7.jpg";